'use strict';

Object.defineProperty(exports, "__esModule", {
  value: true
});

var _react = require('react');

var _react2 = _interopRequireDefault(_react);

var _pure = require('recompose/pure');

var _pure2 = _interopRequireDefault(_pure);

var _SvgIcon = require('material-ui/SvgIcon');

var _SvgIcon2 = _interopRequireDefault(_SvgIcon);

function _interopRequireDefault(obj) { return obj && obj.__esModule ? obj : { default: obj }; }

var SvgIconCustom = global.__MUI_SvgIcon__ || _SvgIcon2.default;

var _ref = _react2.default.createElement('path', { d: 'M21 6h-2v9H6v2c0 .55.45 1 1 1h11l4 4V7c0-.55-.45-1-1-1zm-4 6V3c0-.55-.45-1-1-1H3c-.55 0-1 .45-1 1v14l4-4h10c.55 0 1-.45 1-1z' });

var QuestionAnswer = function QuestionAnswer(props) {
  return _react2.default.createElement(
    SvgIconCustom,
    props,
    _ref
  );
};

QuestionAnswer = (0, _pure2.default)(QuestionAnswer);
QuestionAnswer.muiName = 'SvgIcon';

exports.default = QuestionAnswer;


//////////////////
// WEBPACK FOOTER
// ./~/material-ui-icons/QuestionAnswer.js
// module id = 2747
// module chunks = 0